import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Button, Grid} from '@material-ui/core';

export default class SubscriptionOverview extends React.Component {
  static propTypes = {
    urlPrefix: PropTypes.string.isRequired,
    activatedSubscriptions: PropTypes.number.isRequired,
    pendingSubscriptions: PropTypes.number.isRequired,
    availableSubscriptions: PropTypes.number,
    allocatedSubscriptions: PropTypes.number,
    purchasedSubscriptions: PropTypes.number,
    hideViewDetail: PropTypes.bool.isRequired,
    ofClassroom: PropTypes.bool.isRequired,
    unallocateUnusedSubscriptions: PropTypes.func,
  };
  static defaultProps = {
    hideViewDetail: false,
    ofClassroom: false,
  };

  render() {
    const {
      urlPrefix,
      activatedSubscriptions,
      pendingSubscriptions,
      availableSubscriptions,
      allocatedSubscriptions,
      purchasedSubscriptions,
      hideViewDetail,
      ofClassroom,
      unallocateUnusedSubscriptions,
    } = this.props;
    return (
      <div>
        <h3 className="section-header">
          <div className="section-title">{ofClassroom ? 'Classroom Subscriptions' : 'School Subscriptions'}</div>
          <div className="pull-right">
            {!hideViewDetail && (
              <Link to={`${urlPrefix}/subscriptions`}>
                <Button variant="contained" color="primary">
                  View Subscriptions
                </Button>
              </Link>
            )}
            {unallocateUnusedSubscriptions && (
              <Button variant="contained" onClick={unallocateUnusedSubscriptions} className="small-margin">
                Unallocate Unused Subscriptions
              </Button>
            )}
          </div>
        </h3>
        <Grid container spacing={2} className="school-subscriptions-overview" justify="space-around">
          <Grid item className="subscriptions-figure">
            <h4>Activated</h4>
            <span>{activatedSubscriptions}</span>
          </Grid>
          <Grid item className="subscriptions-figure">
            <h4>Pending</h4>
            <span>{pendingSubscriptions}</span>
          </Grid>
          {!ofClassroom && (
            <Grid item className="subscriptions-figure">
              <h4>Allocated</h4>
              <span>{allocatedSubscriptions}</span>
            </Grid>
          )}
          <Grid item className="subscriptions-figure">
            <h4>Available</h4>
            <span>
              {Number.isInteger(availableSubscriptions)
                ? availableSubscriptions
                : purchasedSubscriptions - allocatedSubscriptions}
            </span>
          </Grid>
          {!ofClassroom && (
            <Grid item className="subscriptions-figure">
              <h4>Total</h4>
              <span>{purchasedSubscriptions}</span>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}
